import React from 'react';
import { Row } from 'react-bootstrap';

import { rawSafeHtmlProps } from '../../utils';
import { ResourceContent } from '../multi-tenant';

export const ResourcesAdditionalResourcesTab = () => {
  return (
    <>
      <Row className='col-lg-7 col-sm-6 ms-4'>
        <div className='custom-links'>
          <ResourceContent
            contentKey='resources.body'
            sourceDataKey='content'
            render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
          />
        </div>
      </Row>
    </>
  );
};
